"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
// TODO get metrics-specific colors into the design-approved
// common styles to shrare across web and phoenix
exports.MetricBlue = '#4996B2';
exports.baseDiv = {
    height: widgets_1.TabStyles.Sizing.BaseUnit,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
};
exports.canvasStyle = {
    minWidth: '100px',
    minHeight: '100px',
    borderStyle: 'solid',
    borderWidth: widgets_1.TabStyles.Sizing.BorderWidth * 2,
    borderColor: widgets_1.TabStyles.Colors.L2_5,
    textAlign: 'center',
    padding: '10px 18px 18px 18px',
    display: 'flex',
    flexDirection: 'column'
};
exports.detailStyle = {
    minWidth: '100px',
    minHeight: '100px',
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 18px 18px 18px',
};
exports.dateStyle = {
    color: widgets_1.TabStyles.Typography.Color.PrimaryLight,
    fontSize: widgets_1.TabStyles.Typography.Sizing.Small,
    textAlign: 'center',
    height: widgets_1.TabStyles.Sizing.ListRowHeight * 3,
    fontFamily: 'Benton Sans',
};
exports.defaultStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
};
exports.detailValueStyle = {
    fontWeight: 300,
    fontSize: '56px',
    color: '#2A79AF',
};
exports.differenceLabelStyle = {
    color: widgets_1.TabStyles.Colors.F6,
    fontSize: widgets_1.TabStyles.Typography.Sizing.Large,
    textTransform: 'uppercase',
    fontFamily: 'Benton Sans',
};
exports.labelStyle = {
    color: widgets_1.TabStyles.Typography.Color.PrimaryLight,
    fontSize: '38px',
    textAlign: 'center',
    height: widgets_1.TabStyles.Sizing.ListRowHeight * 3,
};
exports.lastUpdateLabelStyle = {
    fontFamily: 'Benton Sans',
    color: widgets_1.TabStyles.Typography.Color.Disabled,
    paddingBottom: 5
};
exports.offTrackStyle = {
    color: widgets_1.TabStyles.Colors.AttentionLight,
    fontFamily: 'Benton Sans',
};
exports.onTrackStyle = {
    color: widgets_1.TabStyles.Colors.GoLight,
    fontFamily: 'Benton Sans',
};
exports.referenceLineStyle = {
    flex: .6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    background: widgets_1.TabStyles.Colors.L2_5,
    fontFamily: 'Benton Sans',
    fontSize: widgets_1.TabStyles.Typography.Sizing.Large
};
exports.titleStyle = {
    color: '#367e9c',
    fontSize: '14px',
    fontWeight: 300,
    textTransform: 'uppercase',
    fontFamily: 'Benton Sans',
};
exports.valueStyle = {
    fontFamily: 'Benton Sans',
    fontWeight: 100,
    fontSize: '55px',
    color: widgets_1.TabStyles.Typography.Color.PrimaryMedium,
};
//# sourceMappingURL=styles.js.map